import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "p-grid p-m-0 p-fluid p-jc-center",
  style: {"overflow":"auto"}
}
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-6 p-mb-3" }
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "type",
  class: "kn-material-input-label"
}
const _hoisted_8 = {
  key: 0,
  class: "p-field p-col-2 p-mb-3"
}
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = {
  for: "width",
  class: "kn-material-input-label"
}
const _hoisted_11 = { id: "width-help" }
const _hoisted_12 = {
  key: 1,
  class: "p-field p-col-2 p-mb-3"
}
const _hoisted_13 = { class: "p-float-label" }
const _hoisted_14 = {
  for: "height",
  class: "kn-material-input-label"
}
const _hoisted_15 = { id: "height-help" }
const _hoisted_16 = { class: "p-field p-col-6 p-mb-3" }
const _hoisted_17 = { class: "p-input-icon-right" }
const _hoisted_18 = { class: "p-float-label" }
const _hoisted_19 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_20 = { class: "p-field p-col-6 p-mb-3" }
const _hoisted_21 = { class: "p-input-icon-right" }
const _hoisted_22 = { class: "p-float-label" }
const _hoisted_23 = {
  for: "breadcrumb",
  class: "kn-material-input-label"
}
const _hoisted_24 = { class: "p-field p-col-4 p-mb-3" }
const _hoisted_25 = { class: "p-float-label" }
const _hoisted_26 = {
  for: "origin",
  class: "kn-material-input-label"
}
const _hoisted_27 = { class: "p-field p-col-2 p-mb-3" }
const _hoisted_28 = { class: "p-field p-col-4 p-mb-3" }
const _hoisted_29 = { class: "p-float-label" }
const _hoisted_30 = {
  for: "target",
  class: "kn-material-input-label"
}
const _hoisted_31 = { class: "p-field p-col-2 p-mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_DocParameters = _resolveComponent("DocParameters")
  const _component_Card = _resolveComponent("Card")
  const _component_DocDialog = _resolveComponent("DocDialog")
  const _component_HintDialog = _resolveComponent("HintDialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-p-0 p-m-0" }, {
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-button-text p-button-rounded p-button-plain",
          disabled: _ctx.buttonDisabled,
          onClick: _ctx.hadleSave
        }, null, 8, ["disabled", "onClick"]),
        _createVNode(_component_Button, {
          class: "p-button-text p-button-rounded p-button-plain",
          icon: "pi pi-times",
          onClick: _ctx.closeTemplate
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Card, { class: "p-m-2" }, {
        content: _withCtx(() => [
          _createVNode("form", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("span", _hoisted_4, [
                _createVNode(_component_InputText, {
                  id: "name",
                  class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.simpleNavigation.name.$invalid && _ctx.v$.simpleNavigation.name.$dirty
                                }],
                  type: "text",
                  modelValue: _ctx.v$.simpleNavigation.name.$model,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.simpleNavigation.name.$model = $event)),
                  modelModifiers: { trim: true },
                  maxLength: "40",
                  onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.simpleNavigation.name.$touch())),
                  onInput: _ctx.setDirty
                }, null, 8, ["modelValue", "class", "onInput"]),
                _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('common.name')) + " * ", 1)
              ]),
              _createVNode(_component_KnValidationMessages, {
                class: "p-mt-1",
                vComp: _ctx.v$.simpleNavigation.name,
                additionalTranslateParams: { fieldName: _ctx.$t('common.name') }
              }, null, 8, ["vComp", "additionalTranslateParams"])
            ]),
            _createVNode("div", {
              class: _ctx.simpleNavigation.type === 2 ? 'p-field p-col-2 p-mb-3' : 'p-field p-col-6 p-mb-3'
            }, [
              _createVNode("span", _hoisted_6, [
                _createVNode(_component_Dropdown, {
                  id: "type",
                  class: "kn-material-input",
                  modelValue: _ctx.simpleNavigation.type,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.simpleNavigation.type = $event)),
                  options: _ctx.crossModes,
                  optionValue: "value",
                  optionLabel: "name",
                  onChange: _ctx.handleDropdown
                }, null, 8, ["modelValue", "options", "onChange"]),
                _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.crossNavigationManagement.modality')), 1)
              ])
            ], 2),
            (_ctx.simpleNavigation.type === 2)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode("span", _hoisted_9, [
                    _createVNode(_component_InputNumber, {
                      id: "width",
                      inputClass: "kn-material-input",
                      modelValue: _ctx.simpleNavigation.popupOptions.width,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.simpleNavigation.popupOptions.width = $event)),
                      min: 0,
                      useGrouping: false,
                      onInput: _ctx.setDirty
                    }, null, 8, ["modelValue", "onInput"]),
                    _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('managers.crossNavigationManagement.width')), 1)
                  ]),
                  _createVNode("small", _hoisted_11, _toDisplayString(_ctx.$t('managers.crossNavigationManagement.widthHelp')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.simpleNavigation.type === 2)
              ? (_openBlock(), _createBlock("div", _hoisted_12, [
                  _createVNode("span", _hoisted_13, [
                    _createVNode(_component_InputNumber, {
                      id: "height",
                      inputClass: "kn-material-input",
                      modelValue: _ctx.simpleNavigation.popupOptions.height,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.simpleNavigation.popupOptions.height = $event)),
                      min: 0,
                      useGrouping: false,
                      onInput: _ctx.setDirty
                    }, null, 8, ["modelValue", "onInput"]),
                    _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('managers.crossNavigationManagement.height')), 1)
                  ]),
                  _createVNode("small", _hoisted_15, _toDisplayString(_ctx.$t('managers.crossNavigationManagement.heightHelp')), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_16, [
              _createVNode("span", _hoisted_17, [
                _createVNode("span", _hoisted_18, [
                  _createVNode(_component_InputText, {
                    id: "description",
                    class: "kn-material-input",
                    type: "text",
                    modelValue: _ctx.simpleNavigation.description,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.simpleNavigation.description = $event)),
                    modelModifiers: { trim: true },
                    maxLength: "200",
                    onInput: _ctx.setDirty
                  }, null, 8, ["modelValue", "onInput"]),
                  _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('common.description')), 1)
                ]),
                _createVNode("i", {
                  class: "pi pi-info-circle",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.hintDialog('desc')))
                })
              ])
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode("span", _hoisted_21, [
                _createVNode("span", _hoisted_22, [
                  _createVNode(_component_InputText, {
                    id: "breadcrumb",
                    class: "kn-material-input",
                    type: "text",
                    modelValue: _ctx.simpleNavigation.breadcrumb,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.simpleNavigation.breadcrumb = $event)),
                    modelModifiers: { trim: true },
                    maxLength: "200",
                    onInput: _ctx.setDirty
                  }, null, 8, ["modelValue", "onInput"]),
                  _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('managers.crossNavigationManagement.breadCrumbs')), 1)
                ]),
                _createVNode("i", {
                  class: "pi pi-info-circle",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.hintDialog('bread')))
                })
              ])
            ]),
            _createVNode("div", _hoisted_24, [
              _createVNode("span", _hoisted_25, [
                _createVNode(_component_InputText, {
                  id: "origin",
                  class: "kn-material-input",
                  type: "text",
                  modelValue: _ctx.simpleNavigation.fromDoc,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.simpleNavigation.fromDoc = $event)),
                  modelModifiers: { trim: true },
                  disabled: ""
                }, null, 8, ["modelValue"]),
                _createVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('managers.crossNavigationManagement.originDoc')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_27, [
              _createVNode(_component_Button, {
                label: _ctx.$t('common.select'),
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectDoc('origin'))),
                class: "kn-button kn-button--primary"
              }, null, 8, ["label"])
            ]),
            _createVNode("div", _hoisted_28, [
              _createVNode("span", _hoisted_29, [
                _createVNode(_component_InputText, {
                  id: "target",
                  class: "kn-material-input",
                  type: "text",
                  modelValue: _ctx.simpleNavigation.toDoc,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.simpleNavigation.toDoc = $event)),
                  modelModifiers: { trim: true },
                  disabled: ""
                }, null, 8, ["modelValue"]),
                _createVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('managers.crossNavigationManagement.targetDoc')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_31, [
              _createVNode(_component_Button, {
                label: _ctx.$t('common.select'),
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.selectDoc('target'))),
                class: "kn-button kn-button--primary"
              }, null, 8, ["label"])
            ]),
            _createVNode(_component_DocParameters, {
              selectedNavigation: _ctx.navigation,
              onTouched: _ctx.setDirty
            }, null, 8, ["selectedNavigation", "onTouched"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_DocDialog, {
        dialogVisible: _ctx.dialogVisible,
        selectedDoc: _ctx.docId,
        onClose: _cache[14] || (_cache[14] = ($event: any) => (_ctx.dialogVisible = false)),
        onApply: _ctx.hadleDoc
      }, null, 8, ["dialogVisible", "selectedDoc", "onApply"]),
      _createVNode(_component_HintDialog, {
        dialogVisible: _ctx.hintDialogVisiable,
        message: _ctx.hintDialogMessage,
        title: _ctx.hintDialogTitle,
        onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.hintDialogVisiable = false))
      }, null, 8, ["dialogVisible", "message", "title"])
    ])
  ], 64))
}